import {
  CreateButton,
  TopToolbar,
  ListButton,
  EditButton,
  ExportButton,
} from "react-admin";

export const CreateOnlyTopToolbar = () => (
  <TopToolbar>
    <CreateButton sx={{ color: "#291680", fontSize: "0.855rem" }} />
  </TopToolbar>
);

export const ExportOnlyTopToolbar = () => (
  <TopToolbar>
    <ExportButton sx={{ color: "#291680", fontSize: "0.855rem" }} />
  </TopToolbar>
);

export const CreateWithExportOnlyTopToolbar = () => (
  <TopToolbar>
    <CreateButton sx={{ color: "#291680", fontSize: "0.855rem" }} />
    <ExportButton sx={{ color: "#291680", fontSize: "0.855rem" }} />
  </TopToolbar>
);

export const ShowOnlyTopToolbar = () => (
  <TopToolbar>
    <ListButton sx={{ color: "#291680", fontSize: "0.855rem" }} />
    <EditButton sx={{ color: "#291680", fontSize: "0.855rem" }} />
  </TopToolbar>
);

export const ShowOnlyNoEditTopToolbar = () => (
  <TopToolbar>
    <ListButton sx={{ color: "#291680", fontSize: "0.855rem" }} />
  </TopToolbar>
);

export default {
  CreateOnlyTopToolbar,
  ShowOnlyTopToolbar,
  ShowOnlyNoEditTopToolbar,
  CreateWithExportOnlyTopToolbar,
  ExportOnlyTopToolbar,
};
